//import Swiper, {Thumbs,Navigation} from "../../assets/.npm/node_modules/swiper";
import Swiper, { Navigation,Thumbs } from "../../assets/.npm/node_modules/swiper";

export default () => {
    window.lightbox = lightbox;
  window.lightbox.option({
    wrapAround: true,
  });
    const swiperProThumb = new Swiper(".slider-product-thumb", {
        slidesPerView: 3,
        direction: "horizontal",
        spaceBetween: 10,
    
        breakpoints: {
          600: {
            slidesPerView: 4.5,
            direction: "horizontal",
          },
          992: {
            slidesPerView: 4.5,
            direction: "vertical",
          },
        },
      });
    
      const swiperProGallery = new Swiper(".slider-product-gallery", {
        modules: [Thumbs, Navigation],
        slidesPerView: 1,
        allowTouchMove: false,
        watchSlidesProgress: true,
        thumbs: {
          swiper: swiperProThumb,
        },
        navigation: {
          nextEl: ".product-next",
          prevEl: ".product-prev",
        },
      });
};
  